module.exports = __webpack_public_path__ + "static/media/eye.e61c1c07.svg";